import { render } from "./InteractiveVotingPublicModal.vue?vue&type=template&id=81ea28ec&scoped=true"
import script from "./InteractiveVotingPublicModal.vue?vue&type=script&lang=js"
export * from "./InteractiveVotingPublicModal.vue?vue&type=script&lang=js"

import "./InteractiveVotingPublicModal.vue?vue&type=style&index=0&id=81ea28ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ea28ec"]])

export default __exports__